import React from 'react';
import { Button as MuiButton, type ButtonProps as MuiButtonProps } from '@mui/material';

export interface PreviousButtonProps extends Omit<MuiButtonProps, 'variant'> {
    width?: string | number;
}

const PreviousButton: React.FC<PreviousButtonProps> = ({ children, width, sx, ...props }) => {
    return (
        <MuiButton
            {...props}
            sx={{
                fontWeight: 600,
                textTransform: 'none',
                color: '#132F5F',
                ...sx,
            }}
        >
            {children}
        </MuiButton>
    );
};

export default PreviousButton;
